import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ArrayService {
  public mergeMultiDimArray(arr: string[][]): string[] {
    return arr.reduce((a, b) => a.concat(b), []);
  }

  // eslint-disable-next-line
  public uniqueArray(arr: any[]): any[] {
    return arr.filter((v, i, a) => a.indexOf(v) === i);
  }
}
